import {Box, Heading6, styled, Body1, Button} from '../../../ui-library';

export const ModalBox = styled(Box)`
    display: flex;
    flex-direction: column;
    margin: 300px auto;
    width: 600px;
    border-radius: 10px;
    background: #FFFFFF;
`;

export const ModalTitle = styled(Heading6)`
   padding: 16px 24px;
`;

export const Content = styled(Body1)`
    padding: 8px 24px;
`;

export const CancelBtn = styled(Button)`
    ${({ theme }) => theme.typography.button};
    font-size: 14px;
    align-items: center;
`;

export const YesBtn = styled(Button)<{yestextcolor?: string}>`
    ${({ theme }) => theme.typography.button};
    font-size: 14px;
    align-items: center;
    color: ${(props) => props.yestextcolor};
`;

export const ButtonsBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 8px;
    gap: 8px;
`;
